import { render } from "./ProblemsTableRow.vue?vue&type=template&id=da5ff316&ts=true"
import script from "./ProblemsTableRow.ts?vue&type=script&lang=ts&external"
export * from "./ProblemsTableRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__